<template>
    <v-chip v-if="ticket.priority === FreshDeskTicketPrioritiesV1.Low" size="small" color="light-blue-darken-3">LOW</v-chip>
    <v-chip v-else-if="ticket.priority === FreshDeskTicketPrioritiesV1.Medium" size="small" color="amber-darken-3">MEDIUM</v-chip>
    <v-chip v-else-if="ticket.priority === FreshDeskTicketPrioritiesV1.High" size="small" color="red-darken-1">HIGH</v-chip>
    <v-chip v-else-if="ticket.priority === FreshDeskTicketPrioritiesV1.Urgent" size="small" color="red-darken-1">URGENT</v-chip>
    <v-chip v-else color="gray-darken-1" size="small">{{ ticket.priority }}</v-chip>
</template>

<script setup lang="ts">
import { type AccountTicketV1, FreshDeskTicketPrioritiesV1 } from '@geckoal/gecko-api-client'
import { type PropType } from 'vue'

defineProps({
    ticket: {
        type: Object as PropType<AccountTicketV1>,
        required: true
    }
})
</script>
